import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLienPayoffReviewStore } from '../../hooks/useLienPayoffReviewStore';
import { LienPayoffReviewContent } from './lienPayoffReviewDialog';

interface PayoffReviewEmbedProps {
  loanId: number;
  propertyId?: number;
  readOnly?: boolean;
}

// Same DialogContent + Box(m=4) combo StandardDialog (libs/ui/src/lib/components/dialog/dialog.tsx)
// wraps dialogContent with, so this embed (which has no Dialog chrome of its own) keeps
// the identical padding/gap the in-app LienPayoffReviewDialog gets from CustomTaskDialog.
const useStyles = makeStyles(() => ({
  dialogContent: {
    display: 'flex',
  },
}));

// Bare (no Dialog chrome) internal-view content, meant to be embedded via iframe from portal_ui_prv
// (underwriting), which supplies its own modal title/close button. readOnly hides every action.
export const PayoffReviewEmbed = observer(
  ({ loanId, propertyId, readOnly = true }: PayoffReviewEmbedProps) => {
    const classes = useStyles();
    const { lienPayoffReviewStore } = useLienPayoffReviewStore();

    useEffect(() => {
      if (loanId) {
        lienPayoffReviewStore.getScreenData(loanId, propertyId);
      }
    }, [loanId, propertyId]);

    return (
      <DialogContent className={classes.dialogContent}>
        <Box className="dialog-content-box" m={4} flexGrow={1}>
          <LienPayoffReviewContent
            records={lienPayoffReviewStore.records}
            onRefresh={() => loanId && lienPayoffReviewStore.getScreenData(loanId, propertyId)}
            readOnly={readOnly}
            internalView
          />
        </Box>
      </DialogContent>
    );
  }
);
